import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { motion } from 'framer-motion';
import { useStore } from '../store/usestore';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { X } from 'lucide-react';

export const DiasporaCoordinators = () => {
  const { diasporaCoordinators } = useStore();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  if (!diasporaCoordinators || diasporaCoordinators.length === 0) return null;

  return (
    <SectionWrapper id="diaspora" className="bg-gray-50">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Diaspora Coordinators</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-8">
          Our international representatives coordinating support across the globe.
        </p>
        <Link to="/diaspora">
          <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white">
            View All Coordinators
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {diasporaCoordinators.slice(0, 4).map((coordinator, index) => (
          <motion.div
            key={coordinator.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -5 }}
            className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-all hover:border-primary flex flex-col items-center cursor-pointer"
            onClick={() => setSelectedImage(coordinator.image)}
          >
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden bg-gray-100">
              <img
                src={coordinator.image}
                alt="Diaspora Coordinator"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </motion.div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-4 right-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <img 
            src={selectedImage} 
            alt="Coordinator Full View" 
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </SectionWrapper>
  );
};
